/**
 * AlertStatusBadge — color-coded status badge with hover popover explanation.
 */

import { useState, useRef } from 'react';

const STATUS_CLASSES = {
    Waiting: 'na-status--waiting',
    Overdue: 'na-status--overdue',
    Accepted: 'na-status--accepted',
    Cleared: 'na-status--cleared',
    Arrived: 'na-status--arrived',
};

const STATUS_DESCRIPTIONS = {
    Waiting: 'Waiting for alert to be accepted or cleared if accept feature is N/A for device.',
    Overdue: 'Alert has been active over 20 minutes.',
    Accepted: 'Alert has been accepted by a staff member but the device is still in alarm state.',
    Cleared: 'Device has been cleared. If this device is listed for AFR in system settings, it must be accepted and finished through the mobile app.',
    Arrived: 'Staff has accepted the alert and the device\'s alarm state has been cleared. Alert must be finished to close out.',
};

const AlertStatusBadge = ({ status }) => {
    const [open, setOpen] = useState(false);
    const [style, setStyle] = useState({});
    const ref = useRef(null);

    const handleEnter = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect();
            const popoverWidth = 280;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceRight = window.innerWidth - rect.left;

            // Horizontal: if popover would overflow right edge, anchor to right side instead
            const horizontal = spaceRight < popoverWidth + 16
                ? { right: `${window.innerWidth - rect.right}px`, left: 'auto' }
                : { left: `${rect.left}px`, right: 'auto' };

            // Vertical: flip above if not enough space below
            const vertical = spaceBelow < 100
                ? { bottom: `${window.innerHeight - rect.top + 6}px`, top: 'auto' }
                : { top: `${rect.bottom + 6}px`, bottom: 'auto' };

            setStyle({ position: 'fixed', ...horizontal, ...vertical });
        }
        setOpen(true);
    };

    const cls = STATUS_CLASSES[status] || 'na-status--accepted';
    const desc = STATUS_DESCRIPTIONS[status] || '';

    return (
        <span ref={ref} onMouseEnter={handleEnter} onMouseLeave={() => setOpen(false)}>
            <span className={`na-status ${cls}`}>{status || '—'}</span>
            {open && desc ? (
                <div className="na-status-popover" style={style}>{desc}</div>
            ) : null}
        </span>
    );
};

export default AlertStatusBadge;
